/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */

import React from 'react';

const NotFound = () => {
  return (
    <div className="container-fluid">
      <div className="main_content vh-100 main_content_dashboard pd-t-80 d-flex">Not Found</div>
    </div>
  );
};

export default NotFound;
